// extracted by mini-css-extract-plugin
module.exports = {"container":"News_container__13YOG","sheet":"News_sheet__3ZvxW","active":"News_active__3YTg-","margin":"News_margin__yoIU-"};